export function fetchMetaData(_a) {
    var metaSiteId = _a.metaSiteId, appDefId = _a.appDefId, instance = _a.instance;
    var baseUrl = 'https://www.wix.com';
    var search = "?metaSiteId=" + metaSiteId + "&appDefId=" + appDefId;
    return fetch(baseUrl + "/_serverless/js-sdk-dev-service/get-metadata" + search, {
        headers: {
            accept: 'application/json',
            authorization: instance,
        },
    }).then(function (res) {
        if (!res.ok) {
            throw new Error('Could not fetch site metadata');
        }
        return res.json();
    });
}
//# sourceMappingURL=fetchMetaData.js.map